var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"home"}},[_c('Banner'),_c('Experiencia'),_c('Page'),_c('Extra'),_c('Formulario')],1)}
var staticRenderFns = []

export { render, staticRenderFns }